// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + {"522":"661e36091ba2a0c533f2","890":"208d0f39e07f147a2f0a","995":"48b47f885abc7171f466"}[chunkId] + ".min.js";
};